import { useCallback, useRef, useState } from 'react';
import Beeper from './beeper';

type CountInOptions = {
  intervalMs: number;
  startCount?: number;
};

export default function useCountIn() {
  const [count, setCount] = useState(-1);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const optsRef = useRef<CountInOptions | null>(null);

  const cancel = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    setCount(-1);
  }, []);

  const tick = useCallback(() => {
    setCount((prev) => {
      if (prev === 0) {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
        return -1;
      }
      if (prev === 1) {
        return 0;
      }
      if (prev > 0) {
        Beeper.playBeep(0.125, 880, 0.1);
        return prev - 1;
      }
      return -1;
    });
  }, []);

  const start = useCallback(
    (options: CountInOptions) => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      optsRef.current = options;
      const startCount = options.startCount ?? 4;
      setCount(startCount);
      Beeper.playBeep(0.125, 880, 0.1);
      intervalRef.current = setInterval(tick, options.intervalMs);
    },
    [tick],
  );

  return {
    count,
    isActive: count >= 0,
    start,
    cancel,
  };
}
